// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"RentConfirmedModal_textContainer__2G_tf","modal":"RentConfirmedModal_modal__3wT2R"};